import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["illustration", "title", "type", "includeSessionId"];
import { isValidElement } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { Text } from '../../../components/Text/Text';
import { ResultsMessage } from '../ResultsMessage/ResultsMessage';
import { lazyEval } from '../../utils/lazyEval';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const errorTypes = {
  badRequest: {
    image: 'errors/general',
    title: () => unescapedText('ui.UIErrorMessage.badRequest.title')
  },
  error: {
    image: 'errors/general',
    title: () => unescapedText('ui.UIErrorMessage.error.title')
  },
  expired: {
    image: 'errors/hourglass',
    title: () => unescapedText('ui.UIErrorMessage.expired.title')
  },
  notFound: {
    image: 'errors/map',
    title: () => unescapedText('ui.UIErrorMessage.notFound.title')
  }
};
const errors = Object.assign({}, errorTypes, {
  '400': errorTypes.badRequest,
  '403': errorTypes.expired,
  '404': errorTypes.notFound,
  '500': errorTypes.error
});
const getErrorValues = (type = 'error') => errors[type] || errors.error;
const renderTitle = (title = errors['error'].title) => {
  // @ts-expect-error Formatted* components need types to detect isI18nElement
  if ( /*#__PURE__*/isValidElement(title) && title.type.isI18nElement) {
    return /*#__PURE__*/_jsx(Text, {
      as: "h4",
      children: title
    });
  } else if ( /*#__PURE__*/isValidElement(title)) {
    return title;
  } else {
    return /*#__PURE__*/_jsx(Text, {
      as: "h4",
      children: lazyEval(title)
    });
  }
};
export const ErrorMessage = _ref => {
  var _window$hubspot, _window$hubspot2;
  let {
      illustration,
      title,
      type,
      includeSessionId = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    image,
    title: imageTitle
  } = getErrorValues(type);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ResultsMessage, Object.assign({}, rest, {
      illustration: illustration || image,
      title: renderTitle(title || imageTitle)
    })), includeSessionId && ((_window$hubspot = window.hubspot) === null || _window$hubspot === void 0 ? void 0 : _window$hubspot.sessionId) && /*#__PURE__*/_jsxs(Text, {
      color: "text-primary-subtle",
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "foundations-components.ErrorMessage.sessionId.prefix"
      }), (_window$hubspot2 = window.hubspot) === null || _window$hubspot2 === void 0 ? void 0 : _window$hubspot2.sessionId]
    })]
  });
};
ErrorMessage.displayName = 'ErrorMessage';